<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/dealer/products" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Produkt bearbeiten</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="editProductForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-10 form-div">
                <b-form-group id="fieldset-horizontal">
                  <span>Sie können noch weitere Bilder hochladen</span>
                  <!-- <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Der Produktbilder ist erforderlich',
                    }"
                  > -->
                    <vue-dropzone
                      name="productPictures"
                      ref="uploadProductImages"
                      id="example-input-0 dropzone"
                      :useCustomSlot="true"
                      :options="dropzoneOptions"
                      @vdropzone-file-added="(file) => uploadFile(file)"
                      @vdropzone-removed-file="handleRemoveImage"
                      aria-describedby="input-0-live-feedback"
                    >
                      <div class="dropzone dropzone-default" id="kt_dropzone_1">
                        <div class="dropzone-msg dz-message needsclick">
                          <h4>Bitte laden sie Produktbilder hoch</h4>
                          <h5>Dateien hierhin ziehen oder klicken zum Upload</h5>
                          <p>
                            Erlaubte Formate: JPEG, PNG
                            <br />Maximale Upload-Größe: 1MB
                          </p>
                        </div>
                      </div>
                    </vue-dropzone>
                    <!-- <span class="text-danger"
                      ><b>{{ errors[0] }}</b></span
                    > -->
                  <!-- </ValidationProvider> -->
                </b-form-group>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der Produktname ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.productName"
                          :error-messages="errors[0]"
                          label="Produktname"
                          outlined
                        ></v-text-field>
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Produktkategorie ist erforderlich',
                        }"
                      >
                        <v-select
                          :items="categories"
                          v-model="form.productCategory"
                          :error-messages="errors[0]"
                          item-text="category_detail.category_name"
                          item-value="category_detail.id"
                          label="Produktkategorie"
                          outlined
                        />
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <h6>Produktbeschreibung</h6>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Produktbeschreibung ist erforderlich',
                        }"
                      >
                        <!-- <vue-editor
                          placeholder="Produktbeschreibung"
                          :class="errors[0] ? 'error-outline' : ''"
                          v-model="form.productDescription"
                        ></vue-editor> -->
                        <!-- <ckeditor
                          v-model="form.productDescription"
                          :config="editorConfig"
                          @input="updateDescription"
                        ></ckeditor> -->
                        <SummernoteEditor
                          v-model="form.productDescription"
                           :config="editorConfig"
                           @input="updateDescription"
                        />
                        <span class="text-danger"
                          ><b>{{ errors[0] }}</b></span
                        >
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>

                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <!--<ValidationProvider
                        name="product price"
                        rules="required|min_value:1"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Product price is required.',
                        }"
                      >
                        <v-text-field
                          type="number"
                          step="0.01"
                          autocomplete="new-password"
                          v-model="form.productPrice"
                          :error-messages="errors[0]"
                          label="Product Price"
                          outlined
                        ></v-text-field>
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>-->
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Einheit ist erforderlich',
                        }"
                      >
                        <v-select
                          :items="unitsList"
                          v-model="form.productUnit"
                          :error-messages="errors[0]"
                          item-text="unit"
                          item-value="id"
                          label="Einheit"
                          outlined
                        />
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <v-select
                        :items="badges"
                        v-model="form.productBadge"
                        item-text="name"
                        item-value="id"
                        label="Abzeichen"
                        outlined
                        clearable
                      />
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <ValidationProvider
                      rules="required|priceInput"
                      v-slot="{ errors }"
                      :custom-messages="{
                        required: 'Minimum order quantity is required.',
                      }"
                    >
                      <v-text-field
                        autocomplete="new-password"
                        v-model="form.minOrderQuantity"
                        :error-messages="errors[0]"
                        label="Mindestbestellmenge"
                        outlined
                      ></v-text-field>
                      <!-- <span>{{ errors[0] }}</span> -->
                    </ValidationProvider>
                  </div>
                </div>
                <v-divider></v-divider>
                <!-- product feature -->
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <v-combobox
                        v-model="form.productFeatures"
                        :items="allProductFeatures"
                        label="Produkteigentschaften"
                        item-text="feature"
                        item-value="id"
                        multiple
                        outlined
                      ></v-combobox>
                      <!-- <span>{{ errors[0] }}</span>
                      </ValidationProvider> -->
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="age limit"
                        rules="min_value:0"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Das Alters-Limit muss 0 oder größer sein',
                        }"
                      >
                        <v-text-field
                          type="number"
                          autocomplete="new-password"
                          v-model="form.ageLimit"
                          :error-messages="errors[0]"
                          label="Alters-Limit"
                          outlined
                        ></v-text-field>
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <!-- <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Lieferbedingungen sind erforderlich',
                        }"
                      >
                        <v-combobox
                          v-model="form.deliveryOptions"
                          :items="allDeliveryOptions"
                          :error-messages="errors[0]"
                          label="Lieferbedingungen"
                          item-text="lable"
                          item-value="id"
                          multiple
                          outlined
                        ></v-combobox>
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </div> -->
                </div>
                <v-divider></v-divider>
                <!-- end product feature -->
                <!-- product certificate and age -->
                
                <!-- end product certificate and age -->
                <!-- Product Prices -->
                <div
                  class="row"
                  v-for="(pr, i) in form.productPrices"
                  :key="'P' + i"
                >
                  <div class="col-md-3">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required|maxQuantity"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Die Menge ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="pr.quantity"
                          :error-messages="errors[0]"
                          label="Menge (laut Einheit)"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Lagerstand ist erforderlich',
                        }"
                      >
                        <v-text-field
                          type="number"
                          autocomplete="new-password"
                          v-model="pr.stock"
                          :error-messages="errors[0]"
                          min="0"
                          label="Lagerstand"
                          outlined
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-4">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        name="product price"
                        rules="required|priceInput"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der Produktpreis (€) ist erforderlich',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="pr.price"
                          :error-messages="errors[0]"
                          label="Produktpreis (€)"
                          outlined
                        ></v-text-field>
                        <!-- <span>{{ errors[0] }}</span> -->
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div
                    v-if="i > 0"
                    class="col-md-1 plus-circle-btn removeService"
                  >
                    <a @click="removePrice(i)"
                      ><b-icon icon="x-circle"></b-icon
                    ></a>
                  </div>
                  <div class="col-md-1 plus-circle-btn" v-else>
                    <a @click="addPrice"
                      ><b-icon icon="plus-circle"></b-icon
                    ></a>
                  </div>
                </div>
                <v-divider></v-divider>
                <!-- end Product Prices -->
                <!-- Product Information -->
                <div
                  class="row"
                  v-for="(info, i) in form.productInformations"
                  :key="i"
                >
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <v-autocomplete
                        v-model="info.infoId"
                        :items="informations"
                        outlined
                        item-text="lable"
                        item-value="id"
                        label="Produktinformation"
                        clearable
                      ></v-autocomplete>
                    </b-form-group>
                  </div>
                  <div class="col-md-5">
                    <b-form-group id="fieldset-horizontal">
                      <v-select
                        :items="infoValues"
                        v-model="info.value"
                        item-text="lable"
                        item-value="value"
                        label="Wert (Ja/Nein)"
                        outlined
                        clearable
                      />
                    </b-form-group>
                  </div>
                  <div
                    v-if="i > 0"
                    class="col-md-1 plus-circle-btn removeService"
                  >
                    <a @click="removeInformation(i)"
                      ><b-icon icon="x-circle"></b-icon
                    ></a>
                  </div>
                  <div class="col-md-1 plus-circle-btn" v-else>
                    <a @click="addInformation"
                      ><b-icon icon="plus-circle"></b-icon
                    ></a>
                  </div>
                </div>
                <!-- end product information -->
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        type="number"
                        rules="required|priceInput"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Der MWSt. (%) ist erforderlich',
                          min_value: 'Die MWSt. (%) muss 0 oder größer sein',
                        }"
                      >
                        <v-text-field
                          autocomplete="new-password"
                          v-model="form.vatPercent"
                          :error-messages="errors[0]"
                          label="MWSt. (%)"
                          outlined
                          :readonly="isVatReadonly"
                        ></v-text-field>
                        <span>{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6"></div>
                </div>
                <v-divider></v-divider>

               
                <div class="col-md-12" v-if="isPiecesTransferCost">
                  <v-checkbox
                    v-model="isSeparateTransferCosts"
                    label="Geben Sie spezielle Inlands-Lieferspesen nach Stückzahl ein"
                  ></v-checkbox>
                  <div v-if="isSeparateTransferCosts">
                    <v-radio-group v-model="form.product_transport_cost_type" @change="changeTransferCostOption('inland')">
                      <v-radio
                        label="Diese Lieferspesen werden ZUSÄTZLICH zu den Lieferspesen in den allgemeinen Einstellungen verrechnet"
                        value="additional"
                      ></v-radio>
                      <v-radio
                        label="Diese Lieferspesen werden ALTERNATIV zu den Lieferspesen in den allgemeinen Einstellungen verrechnet"
                        value="overwrite"
                      ></v-radio>
                    </v-radio-group>
                    <div
                      class="row mt-5"
                      v-for="(cost, i) in form.transportPieces"
                      :key="'ngf' + i"
                    >
                      <div class="col-md-5">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :custom-messages="{
                            required: 'This is required',
                          }"
                        >
                          <v-text-field
                            type="number"
                            autocomplete="new-password"
                            :error-messages="errors[0]"
                            v-model="cost.quantity"
                            label="Produktmenge"
                            outlined
                            :clearable="form.product_transport_cost_type == 'overwrite'"
                            :readonly="form.product_transport_cost_type != 'overwrite'"
                          ></v-text-field>
                        </ValidationProvider>
                      </div>
                      <div class="col-md-5">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :custom-messages="{
                            required: 'This is required',
                          }"
                        >
                          <v-text-field
                            autocomplete="new-password"
                            v-model="cost.transport_cost"
                            :error-messages="errors[0]"
                            label="Lieferspesen (€)"
                            outlined
                            clearable
                          ></v-text-field>
                        </ValidationProvider>
                      </div>
                      <div class="col-md-2">
                        <a v-if="i > 0 && form.product_transport_cost_type == 'overwrite'" @click="removeTransportPiecesCost(i)"
                          ><b-icon icon="x-circle"></b-icon
                        ></a>
                      </div>
                    </div>
                    <v-btn v-if="form.product_transport_cost_type == 'overwrite'" class="my-5 submit-btn-fill-color" @click="addTransportPiecesCost"
                      >Neu hinzufügen</v-btn
                    >
                  </div>
                </div>

                <v-divider></v-divider>
                <div class="col-md-12" v-if="isFdPiecesTransferCost">
                  <v-checkbox
                    v-model="fdIsSeparateTransferCosts"
                    label="Geben Sie spezielle Auslands-Lieferspesen nach Stückzahl ein"
                  ></v-checkbox>
                  <div v-if="fdIsSeparateTransferCosts">
                    <v-radio-group
                      v-model="form.fd_product_transport_cost_type" @change="changeTransferCostOption('abroad')"
                    >
                      <v-radio
                        label="Diese Lieferspesen werden ZUSÄTZLICH zu den Lieferspesen in den allgemeinen Einstellungen verrechnet"
                        value="additional"
                      ></v-radio>
                      <v-radio
                        label="Diese Lieferspesen werden ALTERNATIV zu den Lieferspesen in den allgemeinen Einstellungen verrechnet"
                        value="overwrite"
                      ></v-radio>
                    </v-radio-group>
                    <div
                      class="row mt-5"
                      v-for="(cost, i) in form.fdTransportPieces"
                      :key="'ngf' + i"
                    >
                      <div class="col-md-5">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :custom-messages="{
                            required: 'This is required',
                          }"
                        >
                          <v-text-field
                            type="number"
                            autocomplete="new-password"
                            :error-messages="errors[0]"
                            v-model="cost.quantity"
                            label="Produktmenge"
                            outlined
                            :clearable="form.fd_product_transport_cost_type == 'overwrite'"
                            :readonly="form.fd_product_transport_cost_type == 'additional'"
                          ></v-text-field>
                        </ValidationProvider>
                      </div>
                      <div class="col-md-5">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :custom-messages="{
                            required: 'This is required',
                          }"
                        >
                          <v-text-field
                            autocomplete="new-password"
                            v-model="cost.transport_cost"
                            :error-messages="errors[0]"
                            label="Lieferspesen (€)"
                            outlined
                            clearable
                          ></v-text-field>
                        </ValidationProvider>
                      </div>
                      <div class="col-md-2">
                        <a v-if="i > 0 && form.fd_product_transport_cost_type == 'overwrite'" @click="removeFdTransportPiecesCost(i)"
                          ><b-icon icon="x-circle"></b-icon
                        ></a>
                      </div>
                    </div>
                    <v-btn v-if="form.fd_product_transport_cost_type == 'overwrite'" class="my-5 submit-btn-fill-color" @click="addFdTransportPiecesCost"
                      >Neu hinzufügen</v-btn
                    >
                  </div>
                </div>

                <div class="fo-row-btn text-right">
                  <v-btn class="submit-btn-fill-outline" @click="goToBack">
                    Abbrechen
                  </v-btn>
                  <v-btn
                    type="button"
                    :disabled="isDraftDisabled"
                    ref="kt_form_submit_btn"
                    @click="saveDraft()"
                    class="submit-btn-fill-outline"
                  >
                    {{ draftText }}
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
    <notifications group="producersproduct" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import config from "@/config/app";
// import adminAPI from "@/api/admin";
import providerAPI from "@/api/provider";
// import CKEditor from "ckeditor4-vue";

// Vue.use(CKEditor);
import SummernoteEditor from '@/components/admin/pages/product/adminProduct/SummernoteEditor.vue';
import HtmlClass from "@/core/services/htmlclass.service";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
Vue.use(Notifications);

import { extend } from "vee-validate";

extend("priceInput", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^[0-9.,]+$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});
extend("maxQuantity", {
  message: (field) => "enter valid value",
  validate: (value) => {
    var regx = /^[1-9000.,]+$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

export default {
  name: "EditProduct",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      const categoryPromise = this.getCategories();
      const paymentOptionsPromise = this.getPaymentOptions();
      const infoPromise = this.getInformation();
      //const ProducerPromise = this.getActiveProducers();
      const badgePromise = this.getActiveBadges();
      this.infoValues = this.getInfoValues();
      const productFeaturesPromise = this.getProductFeatures();
      // const productCertificatePromise = this.getProductCertificates();
      // const deliveryOptionsPromise = this.getDeliveryOptions();
      const statesPromise = this.getStates();
      const unitsPromise = this.getProductUnits();
      const productPromise = this.getProductData();
      // const settingPromise = this.getGeneralSettings();

      Promise.all([
        categoryPromise,
        paymentOptionsPromise,
        infoPromise,
        //ProducerPromise,
        badgePromise,
        productFeaturesPromise,
        // productCertificatePromise,
        // deliveryOptionsPromise,
        statesPromise,
        unitsPromise,
        productPromise,
        // settingPromise,
      ]).then(() => {});
    }
  },
  components: {
    vueDropzone: vue2Dropzone,
    SummernoteEditor,
    // VueEditor,
  },
  data() {
    return {
      dropzoneOptions: {
        url: config.API_URL + "producer/update-product",
        thumbnailWidth: 150,
        maxFilesize: 1,
        maxFiles: 10,
        addRemoveLinks: true,
        autoProcessQueue: false,
        timeout: 20000000,
        acceptedFiles: ".jpeg, .jpg, .png",
        uploadMultiple: true,
        headers: { Authorization: `Bearer ${JwtService.getToken()}` },
      },
      editorConfig: {
        language: 'de',scayt_sLang : 'de_DE'
      },
      submitText: "Abschicken",
      draftText: "Als Entwurf speichern",
      formError: false,
      userId: null,
      formData: [],
      categories: [],
      infoValues: [],
      badges: [],
      unitsList: [],
      paymentOptions: [],
      allProductFeatures: [],
      allProductCertificates: [],
      productAbroadTransportCost: [],
      productTransportCost: [],
      // allDeliveryOptions: [],
      informations: [],
      statesList: [],
      providers: [],
      isSeparateTransferCosts: false,
      fdIsSeparateTransferCosts: false,
      isPiecesTransferCost: false,
      isFdPiecesTransferCost: false,
      imageChanged: "0",
      currentImage: null,
      btnDisable: false,
      btnDraftDisable: false,
      submitStatus: null,
      acceptImageLength: 4,
      oldImages: [],
      isVatReadonly: false,
      oldProductName: "",
      oldProductDescription: "",
      imageRemoved: "0",
      changeDescription: false,
      changeDescCount: 0,
      form: {
        productImages: [],
        productName: "",
        productDescription: "",
        productCategory: "",
        productPrice: "",
        minOrderQuantity: 1,
        ageLimit: 0,
        vatPercent: 0,
        stock: 0,
        productBadge: "",
        productUnit: "",
        productPayOption: "",
        productFeatures: [],
        productCertificates: [],
        // deliveryOptions: [],
        //producer: "",
        productInformations: [],
        stateInformations: [],
        productPrices: [],
        transportPieces: [],
        fdTransportPieces: [],
        product_transport_cost_type: "additional",
        fd_product_transport_cost_type: "additional",
        transportPiecesCopy:[],
        TransportPiecesAbrodCopy:[]
      },
      old_product_status: "",
    };
  },
  watch: {
    "form.minOrderQuantity": function (value) {
      this.form.minOrderQuantity = value;
    },
  },
  methods: {
    addTransportPiecesCost() {
      this.form.transportPieces.push({
        quantity: "",
        transport_cost: "",
      });
    },
    removeTransportPiecesCost(i) {
      this.form.transportPieces.splice(i, 1);
    },
    addFdTransportPiecesCost() {
      this.form.fdTransportPieces.push({
        quantity: "",
        transport_cost: "",
      });
    },
    removeFdTransportPiecesCost(i) {
      this.form.fdTransportPieces.splice(i, 1);
    },
    getInformation() {
      providerAPI
        .getProductInfo()
        .then((response) => {
          if (response.status == "success") {
            this.informations = response.data;
          } else {
            this.$notify({
              group: "producersproduct",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    changeTransferCostOption (type) {
      if (type == 'inland') {
        if (this.productTransportCost.length) {
          this.isSeparateTransferCosts = true;
          this.form.transportPieces = []
          this.productTransportCost.forEach((item) => {
            if(this.form.product_transport_cost_type == item.product_transport_cost_type) {
              this.form.transportPieces.push({
                quantity: item.value,
                transport_cost: item.cost,
              });
            }
          });
          if (this.form.transportPieces.length == 0) {
            this.getGeneralSettings()
          }
        }
      } else if(type == 'abroad') {
        if (this.productAbroadTransportCost.length) {
          this.fdIsSeparateTransferCosts = true;
          this.form.fdTransportPieces = []
          this.productAbroadTransportCost.forEach((item) => {
            if (this.form.fd_product_transport_cost_type == item.product_transport_cost_type) {
                this.form.fdTransportPieces.push({
                  quantity: item.value,
                  transport_cost: item.cost,
                });
              }
          });
          if (this.form.fdTransportPieces.length == 0) {
            this.getGeneralSettings()
          }
        }
      }
    },
    getPaymentOptions() {
      providerAPI
        .getPaymentOptions()
        .then((response) => {
          if (response.status == "success") {
            this.paymentOptions = response.data;
          } else {
            this.$notify({
              group: "producersproduct",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },

    getProductFeatures() {
      providerAPI
        .getProductFeatures()
        .then((response) => {
          if (response.status == "success") {
            this.allProductFeatures = response.data;
          } else {
            this.$notify({
              group: "producersproduct",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
   
    getStates() {
      providerAPI
        .getStates()
        .then((response) => {
          if (response.status == "success") {
            this.statesList = response.data;
          } else {
            this.$notify({
              group: "producersproduct",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },

    getProductUnits() {
      providerAPI
        .getProductUnits()
        .then((response) => {
          if (response.status == "success") {
            this.unitsList = response.data;
          } else {
            this.$notify({
              group: "producersproduct",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    // getDeliveryOptions() {
    //   providerAPI
    //     .getDeliveryOptions()
    //     .then((response) => {
    //       if (response.status == "success") {
    //         this.allDeliveryOptions = response.data;
    //       } else {
    //         this.$notify({
    //           group: "producersproduct",
    //           type: "error",
    //           position: "bottom right",
    //           text: response.msg,
    //           duration: 3000,
    //         });
    //       }
    //     })
    //     .catch((err) => {
    //       this.$notify({
    //         group: "producersproduct",
    //         type: "error",
    //         position: "bottom right",
    //         text: err,
    //         duration: 3000,
    //       });
    //     });
    // },
    getGeneralSettings() {
      providerAPI
        .getGeneralSettings({ id: this.currentUser.id})
        .then((response) => {
          if (response.status == "success") {
            if (response.data.transport_cost_option) {
              if (response.data.transport_cost_option == "pieces") {
                this.isPiecesTransferCost = true;
              }
              if (this.form.vatPercent === "") {
                if (response.data.tax) {
                  this.form.vatPercent = response.data.tax;
                }
              }
              if (!this.form.transportPieces.length) {
                if (
                  response.data.producer_details.general_transport_cost.length
                ) {
                  response.data.producer_details.general_transport_cost.forEach(
                    (item) => {
                      if (item.status === "1" && item.type == "Pieces") {
                        this.form.transportPieces.push({
                          quantity: item.value,
                          transport_cost: item.cost,
                        });
                      }
                    }
                  );
                } else {
                  this.form.transportPieces.push({
                    quantity: "",
                    transport_cost: "",
                  });
                }
              }
            } else {
              this.isPiecesTransferCost = false;
            }

            if (response.data.abroad_transport_cost_option) {
              if (response.data.abroad_transport_cost_option == "pieces") {
                this.isFdPiecesTransferCost = true;
              }
              if (!this.form.fdTransportPieces.length) {
                if (
                  response.data.producer_details.abroad_shipping_transport_cost
                    .length
                ) {
                  response.data.producer_details.abroad_shipping_transport_cost.forEach(
                    (item) => {
                      if (item.status === "1" && item.type == "Pieces") {
                        this.form.fdTransportPieces.push({
                          quantity: item.value,
                          transport_cost: item.cost,
                        });
                      }
                    }
                  );
                } else {
                  this.form.fdTransportPieces.push({
                    quantity: "",
                    transport_cost: "",
                  });
                }
              }
            } else {
              this.isFdPiecesTransferCost = false;
            }
            //this.form.status = response.data[0].is_allowed == 1 ? true : 0;
          } else {
            this.$notify({
              group: "producersproduct",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          this.btnDisable = false;
          this.submitText = "Abschicken";
          // console.log(123);
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 5000,
          });
        });
    },
    getActiveBadges() {
      providerAPI
        .getActiveBadges()
        .then((response) => {
          if (response.status == "success") {
            this.badges = response.data;
          } else {
            this.$notify({
              group: "producersproduct",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },

    getInfoValues() {
      return [
        {
          lable: "Ja",
          value: "Ja",
        },
        {
          lable: "Nein",
          value: "Nein",
        },
      ];
    },
    addInformation() {
      this.form.productInformations.push({
        infoId: "",
        value: "",
      });
    },
    removeInformation(i) {
      this.form.productInformations.splice(i, 1);
    },

    addPrice() {
      this.form.productPrices.push({
        quantity: "",
        price: "",
        stock: ""
      });
    },
    removePrice(i) {
      this.form.productPrices.splice(i, 1);
    },
    goToBack() {
      //this.$router.push({ name: "producer-products" });
      this.$router.push({ path: "/dealer/products" });
    },
    getCategories() {
      providerAPI
        .activeProducerCategory(this.currentUser.id)
        .then((response) => {
          if (response.status == "success") {
            response.data.forEach((item) => {
              if (item.category_detail) {
                this.categories.push(item);
              }
            });
          } else {
            this.$notify({
              group: "producersproduct",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    uploadFile(file) {
      setTimeout(() => {
        if (file.status == "queued") {
          this.form.productImages.push(file);
        }
      }, 500);
    },
    handleRemoveImage(file) {
      var array = this.oldImages.filter((elm) => elm.photo_name !== file.name);
      this.oldImages = array;
      this.imageRemoved = "1";
    },

    getProductData() {
      axios
        .post("producer/edit-product", { id: this.$route.params.id })
        .then((response) => {
          var responseJson = response.data.data;
          if (response.data.status == "success") {
            this.form.productName = responseJson.product_name;
            this.form.productDescription = responseJson.description;
            this.oldProductName = responseJson.product_name;
            this.oldProductDescription = responseJson.description;
            this.form.productPrice = responseJson.price;
            if(responseJson.minimum_order_quantity){
              this.form.minOrderQuantity = responseJson.minimum_order_quantity
            }
            // this.form.stock = responseJson.available_stock;
            this.old_product_status = responseJson.is_status;
            this.form.ageLimit = responseJson.age_limit;
            this.form.vatPercent = responseJson.vat;
            if (responseJson.tranportation_cost.length) {
              this.isSeparateTransferCosts = true;
              this.productTransportCost = responseJson.tranportation_cost
              responseJson.tranportation_cost.forEach((item) => {
                this.form.product_transport_cost_type =
                  item.product_transport_cost_type;
                this.form.transportPieces.push({
                  quantity: item.value,
                  transport_cost: item.cost,
                });
              });
            }
            if (responseJson.abroad_tranportation_cost.length) {
              this.fdIsSeparateTransferCosts = true;
              this.productAbroadTransportCost = responseJson.abroad_tranportation_cost
              responseJson.abroad_tranportation_cost.forEach((item) => {
                this.form.fd_product_transport_cost_type =
                  item.product_transport_cost_type;
                this.form.fdTransportPieces.push({
                  quantity: item.value,
                  transport_cost: item.cost,
                });
              });
            }

            if (responseJson.badge != null) {
              this.form.productBadge = responseJson.badge.badge_id;
            }
            if (responseJson.unit_detail) {
              this.form.productUnit = responseJson.unit_detail.id;
            }

            if (responseJson.pictures.length) {
              this.form.file = responseJson.pictures[0].photo_name;
              this.currentImage = responseJson.pictures[0].photo_path;
            }

            if (responseJson.product_informations.length) {
              responseJson.product_informations.forEach((item) => {
                this.form.productInformations.push({
                  infoId: item.information_id,
                  value: item.value,
                });
              });
            } else {
              this.form.productInformations.push({
                infoId: "",
                value: "",
              });
            }

            // if (responseJson.states.length) {
            //   responseJson.states.forEach((item) => {
            //     this.form.stateInformations.push({
            //       stateId: item.state_id,
            //       postalCode: item.postal_code,
            //     });
            //   });
            // } else {
            //   this.form.stateInformations.push({
            //     stateId: "",
            //     postalCode: "",
            //   });
            // }

            if (responseJson.product_prices.length) {
              responseJson.product_prices.forEach((item) => {
                this.form.productPrices.push({
                  quantity: item.unit_quantity,
                  price: item.price,
                  stock: item.stock
                });
              });
            } else {
              this.form.productPrices.push({
                quantity: "",
                price: "",
                stock: ""
              });
            }

            if (responseJson.category.length) {
              responseJson.category.forEach((item) => {
                this.form.productCategory = item.category_id;
              });
            } else {
              this.form.productCategory = "";
            }
            if (responseJson.features.length) {
              responseJson.features.forEach((item) => {
                this.form.productFeatures.push({
                  feature: item.product_feature_detail.feature,
                  id: item.feature_id,
                });
              });
            }

            // if (responseJson.product_certificate.length) {
            //   responseJson.product_certificate.forEach((item) => {
            //     this.form.productCertificates.push({
            //       lable: item.certificate_detail.lable,
            //       id: item.certificate_id,
            //     });
            //   });
            // }
            // if (responseJson.delivery_options.length) {
            //   responseJson.delivery_options.forEach((item) => {
            //     this.form.deliveryOptions.push({
            //       lable: item.product_delivery_option.lable,
            //       id: item.delivery_option_id,
            //     });
            //   });
            // }
            this.acceptImageLength = 4 - responseJson.pictures.length;
            this.oldImages = responseJson.pictures;
            responseJson.pictures.forEach((item, i) => {
              if (
                item.photo_path.indexOf(".jpg") !== -1 ||
                item.photo_path.indexOf(".jpeg") !== -1
              ) {
                var file = {
                  size: 12345,
                  name: item.photo_name,
                  type: "image/jpeg",
                };
                this.$refs.uploadProductImages.manuallyAddFile(
                  file,
                  item.photo_path
                );
              }
              if (item.photo_path.indexOf(".png") !== -1) {
                var file = {
                  size: 12345,
                  name: item.photo_name,
                  type: "image/png",
                };
                this.$refs.uploadProductImages.manuallyAddFile(
                  file,
                  item.photo_path
                );
              }
            });
            this.getGeneralSettings();
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.$notify({
              group: "producersproduct",
              type: "error",
              position: "bottom right",
              text: responseJson.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    saveDraft() {
      if (this.form.productName && this.form.message !== '<br>') {
        this.btnDisable = true;
        this.btnDraftDisable = true;
        this.draftText = "Wird gespeichert...";
        this.submitStatus = "0";
        // this.form.productDescription = this.form.productDescription.split('<p></p>').join('');

        let formData = new FormData();
        formData.append("id", this.$route.params.id);
        formData.append("user_id", this.currentUser.id);
        formData.append("product_name", this.form.productName);
        formData.append("product_description", this.form.productDescription);
        formData.append("product_category", this.form.productCategory);
        formData.append("minimum_order_quantity", this.form.minOrderQuantity);
        formData.append("edited_by", "dealer");
        formData.append("isOwnTranCost", this.isSeparateTransferCosts);
        formData.append("isForeignOwnTranCost", this.fdIsSeparateTransferCosts);
        //formData.append("age_limit", this.form.ageLimit);
        //formData.append("product_vat", this.form.vatPercent);

        let productAgeLimit = 0;
        if (this.form.ageLimit > 0) productAgeLimit = this.form.ageLimit;

        let productVatPercent = 0;
        if (this.form.vatPercent > 0) productVatPercent = this.form.vatPercent;

        formData.append("age_limit", productAgeLimit);
        formData.append("product_vat", productVatPercent);

        formData.append("badge_id", this.form.productBadge);
        formData.append("unit_id", this.form.productUnit);
        formData.append("product_status", this.submitStatus);
        // formData.append("available_stock", this.form.stock);
        //formData.append("payment_option", this.form.productPayOption);
        // BY DEFAULT SET CREDIT CARD OPTION
        formData.append("payment_option", 1);
        const features = [];
        for (var i = 0; i < this.form.productFeatures.length; i++) {
          features.push(this.form.productFeatures[i].id);
        }
        formData.append("product_features", JSON.stringify(features));

        // const certificates = [];
        // for (var i = 0; i < this.form.productCertificates.length; i++) {
        //   certificates.push(this.form.productCertificates[i].id);
        // }
        // formData.append("product_certificates", JSON.stringify(certificates));

        // const delOptions = [];
        // for (var i = 0; i < this.form.deliveryOptions.length; i++) {
        //   delOptions.push(this.form.deliveryOptions[i].id);
        // }
        // formData.append("delvery_options", JSON.stringify(delOptions));
        formData.append("image_changed", this.imageChanged);
        //formData.append("file", this.form.file);
        for (var i = 0; i < this.form.productImages.length; i++) {
          formData.append("file[" + i + "]", this.form.productImages[i]);
        }
        var oldFiles = [];
        for (var i = 0; i < this.oldImages.length; i++) {
          oldFiles.push(this.oldImages[i].photo_name);
        }
        formData.append("old_file", oldFiles);

        formData.append(
          "product_informations",
          JSON.stringify(this.form.productInformations)
        );
        // formData.append(
        //   "state_informations",
        //   JSON.stringify(this.form.stateInformations)
        // );
        formData.append(
          "product_prices",
          JSON.stringify(this.form.productPrices)
        );
        if (this.isSeparateTransferCosts) {
          formData.append(
            "transport_costs_array",
            JSON.stringify(this.form.transportPieces)
          );
          formData.append(
            "product_transport_cost_type",
            this.form.product_transport_cost_type
          );
        }
        if (this.fdIsSeparateTransferCosts) {
          formData.append(
            "abroad_transport_costs_array",
            JSON.stringify(this.form.fdTransportPieces)
          );
          formData.append(
            "abroad_product_transport_cost_type",
            this.form.fd_product_transport_cost_type
          );
        }

        setTimeout(() => {
          axios
            .request({
              method: "POST",
              url: "producer/update-product",
              mimeType: "multipart/form-data",
              data: formData,
            })
            .then((response) => {
              if (response.data.status == "success") {
                this.btnDisable = false;
                this.btnDraftDisable = false;
                this.draftText = "Als Entwurf speichern";
                this.$notify({
                  group: "producersproduct",
                  type: "success",
                  position: "bottom right",
                  text: response.data.msg,
                  duration: 5000,
                });
                setTimeout(() => {
                  //this.$router.push({ name: "producer-products" });
                  this.$router.push({ path: "/dealer/products" });
                }, 2000);
              } else {
                this.btnDisable = false;
                this.btnDraftDisable = false;
                this.draftText = "Als Entwurf speichern";
                this.$notify({
                  group: "producersproduct",
                  type: "error",
                  position: "bottom right",
                  text: response.data.msg,
                  duration: 5000,
                });
              }
            })
            .catch((err) => {
              this.btnDisable = false;
              this.btnDraftDisable = false;
              this.draftText = "Als Entwurf speichern";
              this.$notify({
                group: "producersproduct",
                type: "error",
                position: "bottom right",
                text: err,
                duration: 5000,
              });
            });
        }, 2000);
      } else {
        this.$notify({
          group: "producersproduct",
          type: "error",
          position: "bottom right",
          text: "Bitte geben Sie den Namen der Unterkunft ein, um ihn als Entwurf zu speichern.",
          duration: 5000,
        });
      }
    },
    updateDescription () {
        this.changeDescCount++
        if (this.changeDescCount > 1) {
          this.changeDescription = true
        }
        // console.log('count', this.changeDescCount)
        // console.log('change description', this.changeDescription)
    },
    onSubmit() {
      this.$refs.editProductForm.validate().then((success) => {
        if (success && this.form.file !== null && this.form.message !== '<br>') {
          this.btnDisable = true;
          this.btnDraftDisable = true;
          this.submitText = "Wird abgeschickt...";
          this.submitStatus = "2";
          // this.form.productDescription = this.form.productDescription.split('<p></p>').join('');
          
          let formData = new FormData();
          formData.append("id", this.$route.params.id);
          formData.append("user_id", this.currentUser.id);
          formData.append("edited_by", "dealer");
          formData.append("product_name", this.form.productName);
          formData.append("product_description", this.form.productDescription);
          formData.append("old_product_name", this.oldProductName);
          formData.append("isOwnTranCost", this.isSeparateTransferCosts);
          formData.append("isForeignOwnTranCost", this.fdIsSeparateTransferCosts);
          formData.append(
            "old_product_description",
            this.oldProductDescription
          );
          // formData.append("available_stock", this.form.stock);
          formData.append("product_category", this.form.productCategory);
          formData.append("minimum_order_quantity", this.form.minOrderQuantity);
          //formData.append("age_limit", this.form.ageLimit);
          //formData.append("product_vat", this.form.vatPercent);
          let productAgeLimit = 0;
          if (this.form.ageLimit > 0) productAgeLimit = this.form.ageLimit;

          let productVatPercent = 0;
          if (this.form.vatPercent > 0)
            productVatPercent = this.form.vatPercent;

          formData.append("age_limit", productAgeLimit);
          formData.append("product_vat", productVatPercent);

          formData.append("badge_id", this.form.productBadge);
          formData.append("unit_id", this.form.productUnit);
          //formData.append("producer_id", this.form.producer);
          formData.append("product_status", this.old_product_status == 0 ? this.submitStatus : this.old_product_status);
          // formData.append("product_status", this.submitStatus);
          // console.log('change description', this.changeDescription)
          formData.append("changeDescription", this.changeDescription);
          //formData.append("payment_option", this.form.productPayOption);
          // BY DEFAULT SET CREDIT CARD OPTION
          formData.append("payment_option", 1);
          const features = [];
          for (var i = 0; i < this.form.productFeatures.length; i++) {
            features.push(this.form.productFeatures[i].id);
          }
          formData.append("product_features", JSON.stringify(features));

          // const certificates = [];
          // for (var i = 0; i < this.form.productCertificates.length; i++) {
          //   certificates.push(this.form.productCertificates[i].id);
          // }
          // formData.append("product_certificates", JSON.stringify(certificates));

          // const delOptions = [];
          // for (var i = 0; i < this.form.deliveryOptions.length; i++) {
          //   delOptions.push(this.form.deliveryOptions[i].id);
          // }
          // formData.append("delvery_options", JSON.stringify(delOptions));
          formData.append("image_changed", this.imageChanged);
          formData.append("image_removed", this.imageRemoved);
          //formData.append("file", this.form.file);
          for (var i = 0; i < this.form.productImages.length; i++) {
            formData.append("file[" + i + "]", this.form.productImages[i]);
          }
          var oldFiles = [];
          for (var i = 0; i < this.oldImages.length; i++) {
            oldFiles.push(this.oldImages[i].photo_name);
          }
          formData.append("old_file", oldFiles);

          formData.append(
            "product_informations",
            JSON.stringify(this.form.productInformations)
          );

          // formData.append(
          //   "state_informations",
          //   JSON.stringify(this.form.stateInformations)
          // );
          formData.append(
            "product_prices",
            JSON.stringify(this.form.productPrices)
          );
          if (this.isSeparateTransferCosts) {
            formData.append(
              "transport_costs_array",
              JSON.stringify(this.form.transportPieces)
            );
            formData.append(
              "product_transport_cost_type",
              this.form.product_transport_cost_type
            );
          }
          if (this.fdIsSeparateTransferCosts) {
            formData.append(
              "abroad_transport_costs_array",
              JSON.stringify(this.form.fdTransportPieces)
            );
            formData.append(
              "abroad_product_transport_cost_type",
              this.form.fd_product_transport_cost_type
            );
          }
          setTimeout(() => {
            axios
              .request({
                method: "POST",
                url: "/producer/update-product",
                mimeType: "multipart/form-data",
                data: formData,
              })
              .then((response) => {
                if (response.data.status == "success") {
                  this.btnDisable = false;
                  this.btnDraftDisable = false;
                  this.submitText = "Abschicken";
                  this.changeDescription = false;
                  this.$notify({
                    group: "producersproduct",
                    type: "success",
                    position: "bottom right",
                    text: response.data.msg,
                    duration: 5000,
                  });
                  setTimeout(() => {
                    //this.$router.push({ name: "producer-products" });
                    this.$router.push({ path: "/dealer/products" });
                  }, 2000);
                } else {
                  this.btnDisable = false;
                  this.btnDraftDisable = false;
                  this.submitText = "Abschicken";
                  this.$notify({
                    group: "producersproduct",
                    type: "error",
                    position: "bottom right",
                    text: response.data.msg,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.btnDraftDisable = false;
                this.submitText = "Abschicken";
                this.$notify({
                  group: "producersproduct",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.$notify({
            group: "producersproduct",
            type: "error",
            position: "bottom right",
            text: 'fehlender obligatorischer Wert oder falsches Format',
            duration: 5000,
          });
          this.btnDisable = false;
          this.btnDraftDisable = false;
        }
      });
    },
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },

    isDisabled: function () {
      return this.btnDisable;
    },
    isDraftDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.form-div {
  margin: auto;
}

.form-errors {
  color: red;
}

.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.draft-button {
  background-color: #ff9419 !important;
}

.draft-button:hover {
  background-color: #e57a00 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}

.mx-datepicker {
  width: 100% !important;
}
</style>
